import '../themeDefaults';

export default ({ datepickerReact, palette, typography }) => ({
  caret: {
    '& svg': {
      fill: palette.grey.G400,
      left: '50%',
      margin: [-8, 0, 0, -7],
      position: 'absolute',
      top: '50%',
      ...datepickerReact.monthYearDropdownCaret,
    },
    height: 34,
    position: 'absolute',
    right: 0,
    top: 0,
    width: 30,
  },
  wrapper: {
    background: palette.background,
    borderRadius: 2,
    boxSizing: 'border-box',
    height: 34,
    position: 'relative',
    width: 75,
    ...datepickerReact.monthYearDropdown,
    '& select': {
      '&::-moz-focus-inner': {
        border: 0,
      },
      '&::-ms-expand': {
        display: 'none',
      },
      '&:focus': {
        outlineColor: datepickerReact.focusColor,
      },
      '-moz-appearance': 'none',
      '-webkit-appearance': 'none',
      appearance: 'none',
      background: 'transparent',
      border: 0,
      borderRadius: 0,
      boxSizing: 'border-box',
      fontFamily: typography.fontFamily,
      fontSize: 14,
      height: '100%',
      lineHeight: '28px',
      option: {
        fontWeight: 'normal',
      },
      padding: [0, 8],
      position: 'relative',
      width: '100%',
      zIndex: 1,
    },
  },
});
